/* eslint-disable object-shorthand */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-const */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { useIntl } from 'umi';
import { accountsGrowthOfFollowersText } from '@op/components/BubbleCommon/copywritingKey/accounts';
import { ServerTimeType } from '@op/components/FilterCommon/types';
import CommonBarAndLine from '@op/pages/accounts/components/CommonBarAndLine';
import { channelColorTextMap, tabOptions } from '@op/pages/accounts/constants';
import { dealwithGrowthChartRatio, dealwithTableCommentData } from '@op/pages/accounts/utils';
import { ColElementItem, initChartDataMap } from '@op/pages/accounts/widgets/ChartCard';
import SubMenuCard from '@op/pages/accounts/widgets/SubMenuCard';
import TableCard from '@op/pages/accounts/widgets/TableCard';
import { getFollowersDataInfo, getPublishingTimelineDataInfo } from '@op/services/accounts';
import { handleMentionData, supplementSingleData } from '@op/utils';
import { formatNewData } from '@op/utils/data';
import { getNeedTime } from '@op/utils/time';
import OpinionsCard from '../OpinionsCard';
import CardLoading from '@op/components/CardLoading';
import "./index.scss";

const OpinionsAccountsFollowers = (props: any) => {
  const { type = 'channel', gameInfo, wholeGameInfo, filter, filterCond, extraParams, formatRule = "intBmk00" } = props || {};
  const keepParams = useMemo(() => {
    if (!filter?.date_type || !filterCond) return {};
    const { entity_image, isConfirm, ...restFilter } = filter || {};
    const { accounts } = filterCond || {};
    return { ...(restFilter || {}), social_media_by_account: accounts, ...extraParams };
  }, [extraParams, filter, filterCond]);
  const { formatMessage } = useIntl();

  const sortChartData = (newArr: any[], sorts: string | any[]) => {
    newArr.sort((a, b) => {
      return a.name.toLocaleLowerCase() === 'others'
        ? 1
        : b.name.toLocaleLowerCase() === 'others'
          ? -1
          : sorts.indexOf(a.name) - sorts.indexOf(b.name);
    });
  };

  // 处理增长量数据方法
  const dealwithGrowth = (
    element: Array<any>,
    timeline_of_start_time: string,
    timeline_of_end_time: string,
    channel_account_split: string,
    sorts: Array<string>,
    dateType: ServerTimeType,
    needTime: any,
  ) => {
    // 处理增长量数据
    let { table } = dealwithGrowthChartRatio(
      timeline_of_start_time,
      timeline_of_end_time,
      element,
      dateType,
    );
    let { newArr, timeArr } = handleMentionData([...(table || [])], needTime);
    newArr = newArr.map((item: { name: string | number; }) => {
      return {
        ...item,
        legendName: item.name,
        splitText: channel_account_split,
        ...(type === 'account' ? {} : channelColorTextMap[item.name] || {}),
      };
    });
    // 将other排序到最后
    sortChartData(newArr, sorts);
    return [timeArr, newArr, table];
  };

  // 处理通用数据方法
  const dealwithCommon = (
    element: Array<any>,
    channel_account_split: string,
    sorts: Array<string>,
    dateType: ServerTimeType,
    needTime: any,
  ) => {
    let { newArr, timeArr } = handleMentionData(element, needTime);
    // 重写后可将改操作一次完成
    newArr = newArr.map((item: any) => {
      return {
        ...item,
        splitText: channel_account_split,
        legendName: item.name,
        ...(type === 'account' ? {} : channelColorTextMap[item.name] || {}),
      };
    });
    // 将other排序到最后
    sortChartData(newArr, sorts);

    let tableRecord = dealwithTableCommentData(element, dateType);

    return [timeArr, newArr, tableRecord];
  };

  /** *********************Engagements*****************************/
  const [engagementsLoading, setEngagementsLoading] = useState<boolean>(false);
  const [engagementsError, setEngagementsError] = useState<boolean>(false);
  const [engagementsSplitText, setEngagementsSplitText] = useState('#_to_#');
  const [engagementsDataMap, setEngagementsDataMap] = useState(
    initChartDataMap(false),
  );
  const [topRightDataType, setTopRightDataType] = useState('engagements');

  const engagementsMap = useMemo(() => {
    return {
      title: formatMessage({ id: 'Publishing Performance' }),
      downloadSheetName: 'Publishing Performance',
      default: SubMenuCard,
      isLeft: false,
      downloadFunc: 'getPublishingTimelineDataInfo',
      setDataType: (value: any) => {
        setTopRightDataType(value);
      },
      dataType: topRightDataType,
      dataMap: engagementsDataMap,
    };
  }, [engagementsDataMap, topRightDataType, formatMessage]);
  // 获取右上角的那个图表数据
  const getTopRightTimeline = async () => {
    setEngagementsLoading(true);
    setEngagementsError(false);
    const { channel, social_media_by_account, region, ...otherParams } =
      keepParams;
    getPublishingTimelineDataInfo({
      ...otherParams,
      accounts: social_media_by_account,
      model_type: type,
      regions: region,
      page: 1,
      page_size: 9,
      channels: channel,
      metrics: tabOptions.map((item) => item.value),
      need_total_link: false,
      sort_model: 'desc',
    }).then((data: any) => {
      let dateType = keepParams.date_type;
      let localNeedTime = getNeedTime(dateType) as any;
      let {
        list,
        timeline_of_start_time,
        timeline_of_end_time,
        channel_account_split,
        sorts,
      } = data || {};
      list = list || {};
      let resultMap = initChartDataMap(false);
      for (const key in list) {
        const element = list[key] || {};
        let newList = formatNewData((element.timeline || []) as any);
        newList = supplementSingleData(
          timeline_of_start_time,
          timeline_of_end_time,
          newList,
          dateType,
          sorts,
        );
        const [x, y, tableRecord] = dealwithCommon(
          newList,
          channel_account_split,
          sorts,
          dateType,
          localNeedTime,
        );
        resultMap[key] = { x, y, tableRecord };
      }
      setEngagementsSplitText(channel_account_split);
      setEngagementsDataMap(resultMap);
      setEngagementsLoading(false);
    });
  };

  /** *********************Followers*****************************/
  const [treeChartDataMap, setTreeChartDataMap] = useState(initChartDataMap());
  const [followersLoading, setFollowersLoading] = useState<boolean>(true);
  const [followersError, setFollowersError] = useState<boolean>(false);
  const [followersSplitText, setFollowersSplitText] = useState('#_to_#');
  const [otherDataType, setOtherDataType] = useState('engagements');

  const getTreeChartDataTimeline = async () => {
    setFollowersLoading(true);
    setFollowersError(false);
    const { channel, social_media_by_account, region, ...otherParams } =
      keepParams;
    getFollowersDataInfo({
      ...otherParams,
      accounts: social_media_by_account,
      model_type: type,
      regions: region,
      metrics: [...tabOptions?.map((item) => item.value), 'followers'],
      page: 1,
      page_size: 9,
      channels: channel,
      need_total_link: false,
      sort_model: 'desc',
    }).then((data: any) => {
      let dateType = keepParams.date_type;
      let localNeedTime = getNeedTime(dateType) as any;
      let {
        list,
        timeline_of_start_time,
        timeline_of_end_time,
        channel_account_split,
        sorts,
      } = data || {};
      list = list || {};
      const resultMap = initChartDataMap();
      for (const key in list) {
        const element = list[key];
        // 后期需要对handleMentionData方法进行重写
        let newList = formatNewData((element?.timeline || []) as any);

        const localNewList = supplementSingleData(
          timeline_of_start_time,
          timeline_of_end_time,
          newList,
          dateType,
          sorts,
        );
        // 非增长量数据。Followers和其他tab都要使用
        const [x, y, tableRecord] = dealwithCommon(
          localNewList,
          channel_account_split,
          sorts,
          dateType,
          localNeedTime,
        );

        if (key === 'followers') {
          const local_start_time = moment(timeline_of_start_time)
            .subtract(1, 'days')
            .format('YYYY-MM-DD');
          let localList = supplementSingleData(
            local_start_time,
            timeline_of_end_time,
            newList,
            dateType,
            sorts,
          );
          // 增长量数据。Followers Growth使用
          const [gx, gy, gTableRecord] = dealwithGrowth(
            localList,
            timeline_of_start_time,
            timeline_of_end_time,
            channel_account_split,
            sorts,
            dateType,
            localNeedTime,
          );
          resultMap.followers_growth = {
            x: gx,
            y: gy,
            tableRecord: gTableRecord,
          };
        }
        resultMap[key] = { x: x, y: y, tableRecord: tableRecord };
      }
      setTreeChartDataMap(resultMap);
      setFollowersSplitText(channel_account_split);
      setFollowersLoading(false);
    }).catch((err: any) => {
      console.log(err);
      setFollowersLoading(false);
    });
  };

  const [followersMap, growthOfFollowersMap, growthOfEngagementsMap] =
    useMemo(() => {
      let { followers_growth, followers, ...otherChartData } = treeChartDataMap;
      return [
        {
          title: formatMessage({ id: 'Followers' }),
          downloadSheetName: 'Followers',
          default: CommonBarAndLine,
          table: TableCard,
          xAxisData: followers?.x || [],
          seriesDataArray: followers?.y || [],
          records: followers?.tableRecord || [],
          downloadFunc: 'getFollowersDataInfo',
          theThirdColumnConfig: {
            key: 'value',
            header: formatMessage({ id: 'Followers' }),
          },
          isLeft: true,
          tableHeight: 308,
          noData: followers.y.length === 0,
        },
        {
          title: formatMessage({ id: 'Growth of Followers' }),
          downloadSheetName: 'Growth of Followers',
          default: CommonBarAndLine,
          table: TableCard,
          defaultType: 'line',
          xAxisData: followers_growth?.x || [],
          seriesDataArray: followers_growth?.y || [],
          records: followers_growth?.tableRecord || [],
          isLeft: true,
          downloadFunc: 'getFollowersDataInfo',
          theThirdColumnConfig: {
            key: 'value',
            width: 170,
            header: formatMessage({ id: 'Growth of Followers' }),
          },
          tableHeight: 308,
          noShare: true,
          isCenterAxis: true,
          noData: followers_growth.y.length === 0,
        },
        {
          title: formatMessage({ id: 'Audience Performance' }),
          downloadSheetName: 'Audience Performance',
          default: SubMenuCard,
          isLeft: false,
          noShare: true,
          dataMap: otherChartData,
          isCenterAxis: false,
          downloadFunc: 'getFollowersDataInfo',
          setDataType: (value: any) => {
            setOtherDataType(value);
          },
          dataType: otherDataType,
        },
      ];
    }, [treeChartDataMap, otherDataType, formatMessage]);

  useEffect(() => {
    if (Object.keys(keepParams || {}).length > 0) {
      getTopRightTimeline();
      getTreeChartDataTimeline();
    }
  }, [keepParams, type]);


  const cardList = useMemo(() => {
    // 是否单日
    const isSingleDate = moment(keepParams?.start_time)?.format('YYYY-MM-DD') === moment(keepParams?.end_time)?.format('YYYY-MM-DD');
    // 获取最后一天的数据
    const lastDateValue = followersMap?.records?.filter((item: any) => moment(item.time)?.format('YYYY-MM-DD') === moment(filter.end_time)?.format('YYYY-MM-DD'));
    const followersValue = lastDateValue.reduce((sum, item) => sum + (item?.value || 0), 0);
    // 单日补齐时获取最后一天的数据
    const engagementsList = engagementsMap?.dataMap?.[topRightDataType]?.tableRecord || [];
    const filterEngagementsList = isSingleDate ? engagementsList?.filter((item: any) => moment(item.time)?.format('YYYY-MM-DD') === moment(filter.end_time)?.format('YYYY-MM-DD')) : engagementsList;
    const engagementValue = filterEngagementsList?.reduce((sum, item) => sum + (item?.value || 0), 0);
    // 单日补齐时获取最后一天的数据
    const growthOfEngagementsList = growthOfEngagementsMap?.dataMap?.[topRightDataType]?.tableRecord || [];
    const filterGrowthOfEngagementsList = isSingleDate ? growthOfEngagementsList?.filter((item: any) => moment(item.time)?.format('YYYY-MM-DD') === moment(filter.end_time)?.format('YYYY-MM-DD')) : growthOfEngagementsList;
    const growthOfEngagementValue = filterGrowthOfEngagementsList?.reduce((sum, item) => sum + (item?.value || 0), 0);
    const cardList = [
      {
        value: followersValue,
        title: followersMap?.title,
      },
      {
        value: engagementValue,
        title: engagementsMap?.title,
      },
      {
        value: growthOfEngagementValue,
        title: growthOfEngagementsMap?.title,
      },
    ];
    return cardList;
  }, [keepParams?.start_time, keepParams?.end_time, followersMap?.records, followersMap?.title, engagementsMap?.dataMap, engagementsMap?.title, topRightDataType, growthOfEngagementsMap?.dataMap, growthOfEngagementsMap?.title, filter.end_time]);

  return (
    <div className='dbh-opinions-accounts-followers'>
      <CardLoading loading={engagementsLoading || followersLoading}>
        <div className='dbh-opinions-accounts-followers-body'>
          <ColElementItem
            data={growthOfFollowersMap}
            {...{
              loading: followersLoading,
              apiError: followersError,
              splitText: followersSplitText,
              metric: 'followers',
              tips: accountsGrowthOfFollowersText,
              keepParams,
            }}
            type={type}
            defaultChartType="line"
          ></ColElementItem>
          <div className='dbh-opinions-accounts-followers-card-list'>
            {
              cardList?.map((item: any) => <div key={item?.title}>
                <OpinionsCard title={item?.title} value={item?.value} formatRule={formatRule} />
              </div>)
            }
          </div>
        </div>
      </CardLoading >
    </div>
  );
};

export default OpinionsAccountsFollowers;
